(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dumist-outfit-teaser"] && !Shopify.designMode) return;
  try {
    
/* Lecture des vidéos de l'accroche. C'est le script qui décide QUAND une tuile
   se lit, et depuis ce lot, quand elle se TÉLÉCHARGE.

   Le poids d'abord. Ne pas tourner ne suffisait pas : le filtre `video_tag`
   impose `preload="metadata"` dès qu'on lui demande autoplay, et Chrome tirait
   alors le fichier entier au chargement de la page. Mesuré en 390 sans un seul
   défilement, la bande étant à 2757px sous la ligne de flottaison :
   3 582 609 octets de 1080p pour une boîte rendue à 296x445. Le balisage part
   donc sans autoplay, ce qui rend `preload: 'none'` effectif, et la source
   elle-même est déposée puis rendue à l'entrée en vue. Deux verrous, parce que
   `preload` n'est qu'une indication.

   Le repli, ensuite. Sans script, ou sans IntersectionObserver, la tuile montre
   son affiche fixe et ne se lit pas. C'est un recul assumé : l'ancien repli
   « ça se lit quand même » coûtait 3,4 Mo à chaque visiteur mobile.

   Le seuil d'observation, enfin : à 0,35 il n'était JAMAIS atteint en mobile,
   une tuile de carrousel ne montrant que 94px de ses 296px. Il est ramené à
   0,25, le même que l'observateur de la feuille d'achat. */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mounted = new WeakSet();
  var teardowns = new WeakMap();

  function mount(root) {
    if (mounted.has(root)) return;
    mounted.add(root);

    var videos = Array.prototype.slice.call(root.querySelectorAll('video'));
    if (!videos.length) return;

    var cap = parseInt(root.getAttribute('data-teaser-videos') || '0', 10);
    if (!(cap > 0)) cap = 0;

    /* On sort AVANT de toucher aux vidéos : un navigateur sans
       IntersectionObserver ne doit pas se retrouver avec des sources déposées
       que plus personne ne lui rendra. Il garde ses affiches fixes. */
    if (!cap || !('IntersectionObserver' in window)) return;

    videos.forEach(function (video) {
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.pause();
      /* La SOURCE est déposée tant que la tuile n'est pas à l'écran. Ne pas
         lire ne suffisait pas : `video_tag` impose preload="metadata" dès qu'on
         lui demande autoplay, et le fichier entier descendait au chargement de
         la page. L'affiche fixe, elle, reste : la tuile ne clignote pas. */
      Array.prototype.forEach.call(video.querySelectorAll('source[src]'), function (source) {
        source.setAttribute('data-src', source.getAttribute('src'));
        source.removeAttribute('src');
      });
      video.load();
    });

    /* Rend sa source à une vidéo, une seule fois. */
    function arm(video) {
      var waiting = video.querySelectorAll('source[data-src]');
      if (!waiting.length) return;
      Array.prototype.forEach.call(waiting, function (source) {
        source.setAttribute('src', source.getAttribute('data-src'));
        source.removeAttribute('data-src');
      });
      video.load();
    }

    var visible = new Set();

    function sync() {
      var playing = 0;
      var allowed = !REDUCED.matches && !document.hidden;
      videos.forEach(function (video) {
        if (allowed && visible.has(video) && playing < cap) {
          playing += 1;
          arm(video);
          if (video.paused) {
            var attempt = video.play();
            if (attempt && attempt.catch) attempt.catch(function () {});
          }
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    var observer = new IntersectionObserver(
      function (records) {
        records.forEach(function (record) {
          if (record.isIntersecting) visible.add(record.target);
          else visible.delete(record.target);
        });
        sync();
      },
      { threshold: 0.25 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });

    if (REDUCED.addEventListener) REDUCED.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);

    /* Le démontage. Sans lui, chaque rechargement de section dans l'éditeur
       empile un jeu d'écouteurs de plus, chacun retenant une fermeture sur des
       <video> détachés. */
    teardowns.set(root, function () {
      observer.disconnect();
      if (REDUCED.removeEventListener) REDUCED.removeEventListener('change', sync);
      document.removeEventListener('visibilitychange', sync);
      visible.clear();
    });
  }

  function unmount(root) {
    var stop = teardowns.get(root);
    if (stop) {
      stop();
      teardowns.delete(root);
    }
    mounted.delete(root);
  }

  function mountAll(scope) {
    var host = scope || document;
    Array.prototype.forEach.call(host.querySelectorAll('[data-teaser-root]'), mount);
  }

  function unmountAll(scope) {
    var host = scope || document;
    if (host.matches && host.matches('[data-teaser-root]')) unmount(host);
    Array.prototype.forEach.call(host.querySelectorAll('[data-teaser-root]'), unmount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll();
    });
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unmountAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
